define(function(require) {
    var IpsModel = require('civicsBase/ipsModel');
    const ViewManager = require('civicsUtils/view_manager');
    return IpsModel.extend({
        urlRoot: '/delegate/civics-api/api/portal/metadata/detailpage/',
        url:function(){
          if (this.className)
    			   return this.urlRoot + this.className;
          return this.urlRoot;
    	},
        parse: function(response) {
            if(_.isEmpty(response))
                ViewManager.openAlert(i18n.t('CIVICS.DETAIL.ERROR_MESSAGES.PAGE_NOT_GENERATED'));
            else
                return response;
        }
    });
});
